<template>
  <li class="eb-list-item" v-if="dispo">
    
    <EbModal v-if="isDeleteModal" type="destructive" title="Supprimer une disponibilité future ?" text="Vous êtes sur le point de supprimer définitivement une disponibilité future." @close="isDeleteModal=false" @validate="deleteFutureDispo(dispo.id)"></EbModal>
    
    <span class="eb-list-item-content">
      <span class="eb-list-item-title"> À partir du <time :datetime="dispo.dateDebut">{{ getLongDate(dispo.dateDebut) }}</time></span>
      <span>De {{ dispo.libelleTrancheAgeSolis }}</span>
    </span>
    <EbLinkButton :to="{name: 'dispofutureUpdate', params: {dispoId: dispo.id}}" class="text icon-only">
      <font-awesome-icon :icon="['fas', 'pen']" size="lg" /><span class="sr-only">Modifier la disponibilité</span>
    </EbLinkButton>
    <EbButton hierarchy="text" withIcon="icon-only" @click.prevent="isDeleteModal=true">
      <font-awesome-icon :icon="['fas', 'trash']" size="lg" /><span class="sr-only">Supprimer la disponibilité future</span>
    </EbButton>
  </li>
</template>

<script>
export default {
  name: "dispoFuture",
  props: {
    dispo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isDeleteModal: false
    }
  },
  methods: {
    deleteFutureDispo: function(idDispo) {
      this.isDeleteModal = false
      this.$emit('deleteFutureDispo', idDispo)
    }
  }
}
</script>
